import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Form, FormItem } from 'common-components';
import { FiltersDrawer, FiltersDrawerFooter } from '@components/display';
import { css } from '@emotion/react';
import { useAppTranslation } from '@hooks';
import { SegmentDefType, UserAccessLevel } from '@definitions';
import { CommonFilters, StateCheckbox } from '@components/inputs';
import { GetSegmentsPayloadType } from '@api/segment';
import { SelectManagers } from '@views/shared/manager';

type FiltersSegmentsPropsType = {
  visible: boolean
  onFiltersChange?: (filters: GetSegmentsPayloadType) => void
  onClose?: () => void
};

const FiltersSegments = ({ visible, onClose, onFiltersChange }: FiltersSegmentsPropsType) => {
  const { translate } = useAppTranslation();
  const { control, handleSubmit } = useForm<GetSegmentsPayloadType>({
    defaultValues: { model: {} },
  });

  const onSubmit = (data: GetSegmentsPayloadType) => {
    onFiltersChange && onFiltersChange(data);
    onClose && onClose();
  };

  return (
    <FiltersDrawer open={visible} onClose={onClose}>
      <Form
        onReset={() => {
          control._reset();
          onSubmit({ model: {} });
        }}
        onFinish={handleSubmit(onSubmit)}
        css={$form}
      >
        <CommonFilters control={control} />

        <Controller
          control={control}
          render={({ field }) => (
            <FormItem label={translate('common.role')}>
              <StateCheckbox
                inputProps={{
                  onChange: field.onChange,
                  value: field.value as unknown as number[],
                }}
                values={UserAccessLevel}
                labelTxKey={'userAccessLevel'}
                preset={'user-access'}
              />
            </FormItem>
          )}
          name={'model.role'}
        />

        <Controller
          control={control}
          render={({ field }) => (
            <FormItem label={translate('common.state')}>
              <StateCheckbox
                inputProps={{
                  onChange: field.onChange,
                  value: field.value,
                }}
                values={SegmentDefType}
                labelTxKey={'segmentState'}
                preset={'segment-type'}
              />
            </FormItem>
          )}
          name={'model.segmentType'}
        />
        <Controller
          control={control}
          render={({ field }) => (
            <FormItem label={translate('common.managers')}>
              <SelectManagers onChange={field.onChange} value={field.value} />
            </FormItem>
          )}
          name={'model.managers'}
        />

        <FiltersDrawerFooter>
          <Button htmlType="reset">{translate('common.buttons.cancel')}</Button>
          <Button type="primary" htmlType="submit">
            {translate('common.buttons.apply')}
          </Button>
        </FiltersDrawerFooter>
      </Form>
    </FiltersDrawer>
  );
};

export default FiltersSegments;

const $form = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
